<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "App",
  metaInfo() {
    return {
      title:
        this.$store.state.settings.dynamicTitle &&
        this.$store.state.settings.title,
      titleTemplate: (title) => {
        return title
          ? `${title} - ${process.env.VUE_APP_TITLE}`
          : process.env.VUE_APP_TITLE;
      },
    };
  },
};
</script>
<style lang="scss">
#app {
  height: 100%;
}
*,
*::before,
*::after {
  font-family: "Misan", sans-serif;
}
html {
  font-size: 16px; /* 你可以根据需要调整这个值，但建议保持一个易于计算的值，如16px，这样1rem就等于16px */
}
</style>
